/**
 * Snippets Service - API client for agent snippets
 */

import api, { apiEndpoints } from '../lib/api'
import type { AgentSnippet, SnippetsResponse } from '../types/snippets'

export const snippetsApi = {
  /**
   * Fetch snippets for a specific agent
   */
  async getSnippets(agentCode: string): Promise<AgentSnippet[]> {
    const response = await api.get<SnippetsResponse>(
      apiEndpoints.agents.snippets(agentCode)
    )
    return response.data.snippets || []
  },
}
